import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getWalletLegacyId } from 'services/WalletsService'
import { QueryMetaType } from 'types/reactQuery'

export const useGetWalletLegacyId = (walletLsid: string) => {
  const meta: QueryMetaType = {
    errorAdditionalData: { walletLsid },
  }

  return useQuery({
    queryKey: reactQueryKeys.walletLegacyId(walletLsid),
    queryFn: () => getWalletLegacyId(walletLsid),
    enabled: !!walletLsid,
    meta,
  })
}
